var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-text-options",class:_vm.configClasses},[_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.title))]),(_vm.format)?_c('small',[_vm._v(_vm._s(_vm.format))]):_vm._e()]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }